module.exports = __webpack_public_path__ + "static/img/wechat.371aa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat.png
// module id = 83
// module chunks = 0